const keyPrefix = 'session-id-';

const storeSingleTabSession = (projectId: string) => {
    const key = `${keyPrefix}${projectId}`;

    sessionStorage.setItem(key, Date.now().toString())
};

const updateSingleTabSession = (key: string, value: string) => {
    sessionStorage.setItem(key, value)
};

const removeSingleTabSession = (projectId: string) => {
    const key = `${keyPrefix}${projectId}`;

    sessionStorage.removeItem(key);
};

const getSingleTabSession = (projectId: string) => {
    const key = `${keyPrefix}${projectId}`;
    
    return sessionStorage.getItem(key);
};

export { keyPrefix, storeSingleTabSession, removeSingleTabSession, getSingleTabSession, updateSingleTabSession };